import { actionType } from 'redux-postmessage-middleware';
import { IS_FRAMED, FRAME_NAME } from 'utilities/integration/rails';
import { SEND_DATA, SEND_DATA_NOOP, POST_MESSAGE_RESPONSE } from './actionTypes';

const sendData = data => ({
  type: actionType(SEND_DATA),
  data,
  meta: {
    name: FRAME_NAME,
    type: POST_MESSAGE_RESPONSE,
  }
});

const noop = () => {
  // eslint-disable-next-line no-console
  console.warn('no-op: cannot send a post message action without a receiver');
  return {
    type: SEND_DATA_NOOP,
    data: undefined
  };
};

export const sendDataAction = (data) => (IS_FRAMED ? sendData(data) : noop());
export default sendDataAction;
